<template>
  <div class="message-input-container p-3 border-top">
    <BForm @submit.prevent="handleSubmit">
      <BInputGroup>
        <BFormInput
          v-model="messageText"
          placeholder="Введите сообщение..."
          :disabled="!isActive"
        />
        <BButton
          type="submit"
          variant="primary"
          :disabled="!isActive || !messageText.trim()"
        >
          Отправить
        </BButton>
      </BInputGroup>
    </BForm>
  </div>
</template>

<script>
import { ref } from 'vue'
import {
  BForm,
  BInputGroup,
  BFormInput,
  BButton
} from 'bootstrap-vue-next'

export default {
  name: 'MessageInput',
  components: {
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
  },
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  },
  emits: ['send-message'],
  setup(props, { emit }) {
    const messageText = ref('')

    const handleSubmit = () => {
      if (messageText.value.trim()) {
        emit('send-message', messageText.value)
        messageText.value = ''
      }
    }

    return {
      messageText,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.message-input-container {
  background-color: #f8f9fa;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
